export default __webpack_public_path__ + "static/prof-app-mobile-32f0b9a3d6541983762f559424a60804.png";